<div class="active-input-label" data-cy="active-label">Activate or inactivate {{entityName}}</div>

<div fieldset id="active-input-form" class="active-input">
    <div class="active-input-active">
        <input type="radio" id="active" name="active-input-form" class="radio-button-input"
               [attr.checked]="state ? 'checked' : null"
               (change)="updateState(true)"
               data-cy="radio-button-input-active">
        <label for="active" class="active-radio-input-label">Active</label>
    </div>
    <div class="active-input-inactive">
        <input type="radio" id="inactive" name="active-input-form" class="radio-button-input"
               [attr.checked]="!state ? 'checked' : null"
               (change)="updateState(false)"
               data-cy="radio-button-input-inactive">
        <label for="inactive" class="active-radio-input-label">Inactive</label>
    </div>
</div>
